import { fetchWrapper } from "_helpers";

const baseUrl = `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_CONTEXT_PATH}/stockTypes`;

export const materialTypeService = {
  getAll,
  getSuggestion,
  search,
  getById,
  create,
  update,
  delete: _delete,
  uploadBomFile,
  getHistory,
  getDocuments,
  getAllFinished,
  searchFinished,
  getTransactions,
 
};

function getAll() {
  return fetchWrapper.get(baseUrl);
}

function search(params) {
  return fetchWrapper.get(`${baseUrl}${params}`);
}

function getSuggestion(params = null) {
  if (params) {
    return fetchWrapper.get(`${baseUrl}/suggestion${params}`);
  } else {
    return fetchWrapper.get(`${baseUrl}/suggestion`);
  }
}

function getById(id) {
  return fetchWrapper.get(`${baseUrl}/${id}`);
}

function create(params) {
  return fetchWrapper.post(baseUrl, params);
}

function update(id, params) {
  return fetchWrapper.put(`${baseUrl}/${id}`, params);
}

function _delete(id) {
  return fetchWrapper.delete(`${baseUrl}/${id}`);
}

function uploadBomFile(params) {
  return fetchWrapper.post(`${baseUrl}/upload`, params);
}

function getHistory(id) {
  return fetchWrapper.get(`${baseUrl}/${id}/history`);
}

function getDocuments(id) {
  return fetchWrapper.get(`${baseUrl}/${id}/document`);
}

function getTransactions(id) {
  return fetchWrapper.get(`${baseUrl}/${id}/transactions`);
}

function getAllFinished() {
  return fetchWrapper.get(`${baseUrl}/finished-products`);
}

function searchFinished(params) {
  return fetchWrapper.get(`${baseUrl}/finished-products${params}`);
}
